<template class="product-page">
  <div>
    <v-container>
      <div class="row">
        <div class="breadcrumbs_block col-12">
          <!--Breadcrumbs-->
          <v-breadcrumbs :items="breadcrums">
            <template v-slot:divider>
              <v-icon x-small>fa-chevron-right</v-icon>
            </template>
          </v-breadcrumbs>
        </div>
        <!--Main product setup block-->
        <div class="main_product_block col-12">
          <div class="col-10" style="margin: 0 auto;">
            <div class="row">
              <!--Main images block-->
              <v-sheet class="main_product_img_block col-md-6 col-lg-6">
                <div class="main_img">
                  <inner-image-zoom
                    v-if="currentImgSrc !== ''"
                    :src="currentImgSrc"
                    :width="400"
                    :height="500"
                    :className="'carousel_img'"
                    :hasSpacer="true"
                  />
                  <inner-image-zoom
                    v-else
                    :src="product.images[0].src"
                    :width="400"
                    :height="500"
                    :className="'carousel_img'"
                    :hasSpacer="true"
                  />
                </div>
                <hooper
                  :settings="bottomHooperSlider"
                  class="custom_hooper_class mt-10"
                  style="max-height: 70px"
                >
                  <slide v-for="image in product.images" :key="image.id">
                    <v-img
                      :src="image.src"
                      class="slider_img"
                      width="70"
                      height="50"
                      @mouseover="currentImgSrc = image.src"
                    ></v-img>
                  </slide>
                </hooper>
              </v-sheet>
              <!--Main product info block-->
              <v-sheet class="product_info_block col-md-6 col-lg-6">
                <v-card class="product_cart mx-auto">
                  <!--Sale block-->
                  <div
                    class="product_special_offer"
                    v-if="product.availableForSale"
                  >
                    <span class="sale_block">Sale</span>
                  </div>
                  <!--Product title-->
                  <v-card-title class="product_info_title">
                    {{ product.title }}
                  </v-card-title>
                  <!--Current product price-->
                  <v-card-title
                    class="product_info_price"
                    style="padding-top: 0;"
                  >
                    ${{
                      product.price ? product.price : product.variants[0].price.amount +' ' +product.variants[0].price.currencyCode
                    }}
                  </v-card-title>
                  <!--Old product price-->
                  <v-card-subtitle
                    v-if="
                      product.availableForSale &&
                        product.variants[0].compareAtPrice !== null
                    "
                    style="font-size: 18px"
                    class="product_old_price"
                  >
                    Old price:
                    <span> ${{ product.variants[0].compareAtPrice.amount  + ' ' +product.variants[0].price.currencyCode }} </span>
                  </v-card-subtitle>
                  <v-card-text class="mt-2">
                    <!--Rating field-->
                    <v-row align="center" class="mx-0">
                      <v-rating
                        v-model="rating"
                        color="blue"
                        dense
                        half-increments
                        size="14"
                      ></v-rating>
                      <div
                        class="ml-2"
                        :style="{
                          fontSize: '18px',
                          color: rating > 3 ? 'green' : 'red'
                        }"
                      >
                        {{ rating }}(21)
                      </div>
                    </v-row>
                    <!--Size & Color select-->
                    <div class="my-4 subtitle-1">
                      <v-row align="center" class="justify-space-around">
                        <v-col>
                          <v-menu offset-y>
                            <template v-slot:activator="{ attrs, on }">
                              <v-btn
                                class="select_menu mt-5 mb-5"
                                v-bind="attrs"
                                v-on="on"
                              >
                                {{ productVariantName }}
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item
                                v-for="variant in product.variants"
                                :key="variant.id"
                              >
                                <v-list-item-title
                                  style="cursor: pointer;"
                                  @click="
                                    selectCurrentProductVarian(
                                      variant.id,
                                      variant
                                    )
                                  "
                                >
                                  {{ variant.title }}
                                </v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </v-col>
                      </v-row>
                      <v-row class="product_quantity_block" align="center">
                        <v-col>
                          <v-text-field
                            v-model="productQuantity"
                            type="number"
                            label="Quantity"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                    <div class="available_block">
                      <v-icon :color="availableObject.iconColor" size="20">
                        {{ availableObject.iconType }}
                      </v-icon>
                      <span :style="{ color: availableObject.iconColor }">
                        {{ availableObject.text }}
                      </span>
                    </div>
                    <div class="vendor_block">
                      <strong>Vendor:</strong> {{ product.vendor }}
                    </div>
                    <!-- <div class="current_variant_block">
                      <strong>Product variant:</strong> {{ productVariantName }}
                    </div> -->
                    <div class="product_collection_block">
                      <strong>Type:</strong> {{ product.productType }}
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-row>
                      <v-col class="pb-0" cols="12">
                        <v-dialog
                          v-if="!user"
                          v-model="dialog"
                          persistent
                          max-width="400"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="add_product_to_cart_btn"
                              color="primary"
                              dark
                              v-bind="attrs"
                              v-on="on"
                            >
                              ADD TO CART
                            </v-btn>
                          </template>
                          <v-card>
                            <v-card-title class="headline">
                              Want to buy this product
                            </v-card-title>
                            <v-card-text>
                              To do this, you need to be sign in.
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="red darken-1"
                                text
                                @click="dialog = false"
                              >
                                Disagree
                              </v-btn>
                              <v-btn
                                color="green darken-1"
                                text
                                @click="goToSignInFromProduct"
                              >
                                Agree
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        <v-btn
                          v-else
                          class="add_product_to_cart_btn primary white--text"
                          @click="addToCart()"
                          outlined
                          tile
                          dense
                          ><v-icon>mdi-cart</v-icon> ADD TO CART</v-btn
                        >
                      </v-col>
                      <v-col cols="12">
                        <v-btn
                          class="add_product_to_wishlist_btn"
                          disabled
                          outlined
                          tile
                        >
                          ADD TO WISHLIST
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-sheet>
            </div>
          </div>
        </div>
        <div class="product-description-block my-10">
          <v-row>
            <v-col class="product-description-block_title" cols="12">
              ABOUT THE PRODUCT
            </v-col>
            <v-col cols="12">
              <v-tabs background-color="transparent" grow>
                <v-tab v-for="tab in tabsItem" :key="tab">{{ tab }}</v-tab>
                <v-tab-item background-color="transparent">
                  <div class="tab_content">
                    <v-row>
                      <v-col cols="12">
                        <p
                          v-if="!readMoreActivated"
                          v-html="product.descriptionHtml.slice(0, 1000)"
                        ></p>
                      </v-col>
                      <v-col cols="12">
                        <v-btn
                          v-if="!readMoreActivated"
                          @click="readMoreActivated = !readMoreActivated"
                        >
                          read more...
                        </v-btn>
                      </v-col>
                      <v-col cols="12">
                        <p
                          v-if="readMoreActivated"
                          v-html="product.descriptionHtml"
                        ></p>
                      </v-col>
                    </v-row>
                  </div>
                </v-tab-item>
                <v-tab-item background-color="transparent">
                  <div class="tab_content">
                    Best in class material!!! No jokes and this is not marketing
                    strategy :)
                  </div>
                </v-tab-item>
              </v-tabs>
            </v-col>
          </v-row>
        </div>
        <div class="you-may-also-like-block mb-10">
          <v-row>
            <v-col class="you-may-also-like-block_title" cols="12">
              YOU MAY ALSO LIKE
            </v-col>
            <v-col cols="12">
              <div class="other_products_slider">
                <hooper
                  :settings="footerHooperSettings"
                  style="min-height: 370px; padding: 10px;"
                >
                  <slide
                    v-for="item in otherProductsFromCurrentVendor"
                    :key="item.id"
                    class="mx-2"
                  >
                    <div
                      class="slide_element"
                      @click="goToCurrentProduct(item)"
                    >
                      <v-img
                        :src="item.images[0].src"
                        width="200"
                        height="200"
                        contain
                      ></v-img>
                      <div
                        style="width: 100%; height: 2px; background-color: #eeeeee;"
                        class="my-2"
                      ></div>
                      <p>
                        {{ titleCorrection(item.title) }}
                      </p>
                      <div>
                        <strong class="mr-1">
                          ${{
                            item.price ? item.price : item.variants[0].price.amount + item.variants[0].price.currencyCode
                          }}
                        </strong>
                        <span
                          v-if="
                            item.availableForSale &&
                              item.variants[0].compareAtPrice !== null
                          "
                          class="product_old_price"
                        >
                          ${{ item.variants[0].compareAtPrice.amount + item.variants[0].compareAtPrice.currencyCode }}
                        </span>
                      </div>
                    </div>
                  </slide>
                  <hooper-progress slot="hooper-addons"></hooper-progress>
                </hooper>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-container>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { Hooper, Slide, Progress as HooperProgress } from "hooper";
import "hooper/dist/hooper.css";
import { bottomSlider, footerSlider } from "../constants/sliderBreakpoints";

export default {
  data: () => ({
    readMoreActivated: false,
    dialog: false,
    productVariantName: "Select variant",
    tabsItem: ["Description", "Materials"],
    productQuantity: 1,
    rating: 4.5,
    dataVariantId: 0,
    currentImgSrc: "",
    bottomHooperSlider: bottomSlider,
    footerHooperSettings: footerSlider
  }),
  components: {
    Hooper,
    Slide,
    HooperProgress
  },

  computed: {
    ...mapGetters(["loading", "error", "user", "products", "cart"]),

    breadcrums() {
      return [
        {
          text: "Home",
          disabled: false,
          href: window.location.origin
        },
        {
          text: this.$route.name,
          disabled: false,
          href: `/shop/shop_list`
        },
        {
          text: this.product.productType,
          disabled: false,
          // In future we need set href to current collection in router
          href: "/"
        },
        {
          text: this.product.title,
          disabled: true,
          href: this.$route.fullPath
        }
      ];
    },

    availableObject() {
      return {
        iconColor: this.product.variants[0].available ? "green" : "red",
        iconType: this.product.variants[0].available
          ? "fa-check-circle"
          : "fa-minus-circle",
        text: this.product.variants[0].available ? "In stock" : "Not available"
      };
    },
    product() {
      if (Object.values(this.products).length > 0) {
        return this.products.filter(
          item => item.id === this.$route.params.id
        )[0];
      } else {
        return [];
      }
    },
    otherProductsFromCurrentVendor() {
      return this.products.filter(el => el.vendor === this.product.vendor);
    },
    id() {
      return this.$route.params.id;
    },
    computedDataVariantId() {
      return this.dataVariantId || this.product.variants[0].id;
    }
  },
  methods: {
    ...mapActions(["addProductToCart"]),
    goToSignInFromProduct() {
      this.dialog = false;
      this.$router.push("/auth/signin");
    },
    goToCurrentProduct(item) {
      this.currentImgSrc = "";
      this.productVariantName = "Select variant";
      this.readMoreActivated = false;
      this.productQuantity = 1;
      if (this.$route.params.id !== item.id) {
        this.$router.push(`/product/${item.id}`);
      }
    },
    addToCart() {
      this.addProductToCart({
        product: this.product,
        computedDataVariantId: this.computedDataVariantId,
        productQuantity: this.productQuantity
      });
      // this.productQuantity = 1;
      // this.productVariantName = "Select variant";
    },
    selectCurrentProductVarian(id, element) {
      this.registerVariantInput(id);
      this.productVariantName = element.title;
      if (this.currentImgSrc !== element.image.src) {
        this.currentImgSrc = element.image.src;
      }
    },
    registerVariantInput(id) {
      this.dataVariantId = id;
    },
    titleCorrection(title) {
      return title.length > 20 ? title.substring(0, 20) + "..." : title;
    }
  },
  created() {
    // this.initFirstVariant()
  },
  beforeCreate() {},
  mounted() {
    // ? Mounted hook can catch first update of editData
    console.log(this.product);
  },
};
</script>

<style lang="scss">
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .product_info_title {
    font-size: 20px !important;
  }
  .product_info_price {
    font-size: 20px !important;
  }

  .main_img {
    height: 260px !important;
  }

  .breadcrumbs_block {
    margin-left: 30px;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .breadcrumbs_block {
    margin-left: 30px;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .product_info_title {
    font-size: 25px !important;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .product_info_title {
    font-size: 30px !important;
  }
  .product_info_price {
    font-size: 25px !important;
  }
}
.v-item-group {
  background-color: transparent !important;
}
.product-page > v-btn {
  margin-bottom: 50px;
}

.product_slider {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border: 2px solid #eeeeee !important;
}

.main_img {
  width: 100%;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.hooper-slide {
  text-align: center !important;
}

.hooper-track {
  padding: 0 !important;
  margin: 0 auto !important;
}

.hooper-list {
  text-align: center !important;
  margin: 0 auto !important;
}

.slider_img {
  margin: 5px;
}

.slider_img:hover {
  border: 1px solid black;
  box-shadow: 0 0 6px #1e88e5;
}

.carousel_img {
  width: 100%;
  height: 100%;
  cursor: zoom-in;
}

.main_product_img_block {
  display: flex;
  flex-direction: column;
  align-items: center !important;
  justify-content: center;
}

.product_cart {
  width: 100%;
  height: 100%;
  padding: 10px;
  box-shadow: none !important;
  border: 2px solid #eeeeee !important;
}

.sale_block {
  padding: 3px 15px;
  background-color: red;
  color: white;
  font-weight: bold;
  font-size: 15px;
}

.product_old_price {
  text-decoration: line-through;
  text-decoration-color: red;
}

.available_block {
  display: flex;
  align-items: center;
}

.available_block > span {
  margin-left: 10px;
}

.product_quantity_block {
  margin: 0 !important;
}

.product_quantity_block > div {
  padding: 0 !important;
}

.add_product_to_cart_btn {
  width: 100%;
}

.add_product_to_wishlist_btn {
  width: 100%;
}

.select_menu {
  width: 100%;
  background-color: white !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  border-bottom: 1px solid #949494;
}

.product-description-block {
  width: 100%;
  background-color: #f6f5f6;
  border: 2px solid #eeeeee !important;

  &_title {
    margin: 20px 0;
    text-align: center;
    padding: 20px;
    font-size: 25px;
    font-weight: bold;
  }
}

.tab_content {
  padding: 30px;
}

.you-may-also-like-block {
  width: 100%;

  &_title {
    margin: 20px 0;
    text-align: center;
    padding: 20px;
    font-size: 25px;
    font-weight: bold;
  }
}

.slide_element {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  overflow: auto;
}

.slide_element:hover {
  border: 1px solid #e0e0e0;
}

.slide_element > span {
  padding-top: 10px;
}
</style>
